import Icon from '@mdi/react';
import { mdiAlertCircle } from '@mdi/js';


const ErrorPage = () => {

	return(
		<>
		<div className="d-flex justify-content-center">
			<h2 className="error-page">Error 404 Page not found</h2>
		</div>
		<div className="d-flex justify-content-center">
			<Icon path={mdiAlertCircle} size={10} />
		</div>
		</>
	)
}

export default ErrorPage;